import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import SDButtonGroup from '@/shared/components/SDComponentsNewDesign/SDButtonGroup/SDButtonGroup'
import getError from '@/containers/SubscriptionFormPageNew/getError'

const RecentInsulationWorkField = () => {
  const { t, energyLandscape, updateAddressEnergyLandscape, errors } = useAddress()

  return (
    <SDFormControl
      plainLabel
      label={t('subscriptionTools:estimator.recent_insulation_work.label')}
      error={getError('recentInsulationWork', errors)}
    >
      <SDButtonGroup
        onClickHandler={value => {
          updateAddressEnergyLandscape({ recentInsulationWork: value })
        }}
        options={[{ YES: 'Oui' }, { NO: 'Non' }]}
        selectedValue={energyLandscape?.recentInsulationWork}
      />
    </SDFormControl>
  )
}

export default RecentInsulationWorkField
